import { Flex } from '@chakra-ui/react'
import { useCallback, useMemo, useState } from 'react'

import MainFilterSection from './Filters'
import moment from 'moment'
import AboutDataPopover from './AboutDataPopover'
import { MainSection } from './MainSection'
import { useEffect } from 'react'
import useTestPositivityData from './apis/useTestPositivityData'
import UpsellBanner from './UpsellBanner'
import useTracking from 'tracking/useTracking'
import { getCountryName } from './getCountryName'

export interface FiltersT {
  dataType: { value: string; label: string }[]
  dateRange: {
    start: string
    end: string
  }
  country: string
}

const _DefaultFilters = {
  dataType: [{ value: 'infections', label: 'Infections' }],
  dateRange: {
    start: moment().subtract(2, 'months').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
  },
  country: 'USA',
}

const EpidDashboard = () => {
  const [tracking] = useTracking()
  const { data } = useTestPositivityData()

  const diseaseOptions = useMemo(
    () =>
      Array.from(new Set(data?.map((x) => x.disease_name))).sort((a, b) =>
        a.localeCompare(b)
      ),
    [data]
  )
  const countryOptions = useMemo(
    () => Array.from(new Set(data?.map((x) => x.country_alpha_3))),
    [data]
  )

  const [filters, setFilters] = useState<FiltersT>(_DefaultFilters)

  useEffect(() => {
    setFilters({
      dataType: diseaseOptions.map((x) => ({ value: x, label: x })),
      dateRange: {
        start: moment().subtract(12, 'months').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      },
      country: 'USA',
    })
  }, [data, diseaseOptions])

  const selectCountry = useCallback(
    (country: string) => {
      setFilters((fil) => ({ ...fil, country }))
      tracking.countryFilterChanged({ country: getCountryName(country) })
    },
    [tracking]
  )
  const changeDateRange = useCallback(
    (start: string, end: string) => {
      setFilters((fil) => ({ ...fil, dateRange: { start, end } }))
      tracking.dateRangeFilterChanged({ dateStart: start, dateEnd: end })
    },
    [tracking]
  )

  return (
    <Flex flexDir={'column'} gap='1rem'>
      <Flex gap='1rem' alignItems={'center'}>
        <AboutDataPopover />
        <MainFilterSection
          countries={countryOptions || []}
          diseaseOptions={diseaseOptions}
          handleFilters={setFilters}
          handleCountry={selectCountry}
          filters={filters}
        />
      </Flex>
      <MainSection filters={filters} changeDateRange={changeDateRange} />
      <UpsellBanner />
    </Flex>
  )
}

export default EpidDashboard
